<script setup lang="ts">
  import BaseListAmp from '~/components/old-recipes/BaseList.amp.vue';
  import { getIsoDuration, getPrepTimeFormattedFull } from '~/utils';

  const props = defineProps<{
    elem: TContent<{
      total: number;
      active: number;
      yield: number;
    }>;
  }>();

  const cookingTime = computed(() => {
    const items = [
      {
        text: 'Общее',
        amount: getPrepTimeFormattedFull(props.elem.attributes.total).toString(),
        machineAmount: getIsoDuration(props.elem.attributes.total),
        description: '',
      },
    ];

    if (props.elem.attributes.active) {
      items.push({
        text: 'Активное',
        amount: getPrepTimeFormattedFull(props.elem.attributes.active).toString(),
        description: '(требуется ваше участие)',
      });
    }

    return items;
  });

  const cookingTimeHrecipeClasses = computed(() => ['duration']);

  const portions = computed(() => {
    return [
      {
        text: 'Количество порций',
        amount: props.elem.attributes.yield.toString(),
        description: '',
      },
    ];
  });
</script>

<template>
  <BaseListAmp
    title-tag-name="h2"
    title="Время приготовления"
    :items="cookingTime"
    :hrecipe-time-classes="cookingTimeHrecipeClasses"
  />

  <BaseListAmp
    v-if="props.elem.attributes.yield"
    type="portions"
    title=""
    :items="portions"
    :hrecipe-yield="true"
  />
</template>
